import React from 'react';
import { PropTypes } from 'prop-types';
import { Field, arrayRemove } from 'redux-form';
import { connect } from 'react-redux';
import FieldChangeWrapper from 'components/Common/FieldChangeWrapper';

export const resolveObjPath = (path, obj) => path
  .split('.')
  .reduce(
    (prev, curr) => (
      prev
        ? prev[curr]
        : undefined
    ),
    obj || window.self
  );

const NestedArrayObjectFieldInput = ({
  input,
  meta,
  placeholder,
  type,
  className,
  maxLength
}) => (
  <div>
    <input
      type={ type }
      { ...input }
      placeholder={ placeholder }
      className={ className }
      { ...(maxLength && maxLength > 0 && { maxLength }) }
      onBlur={ (e) => {
        const { value } = e.target;
        input.onBlur(value === '' ? null : value);
      } }
      onChange={ (e) => {
        const { value } = e.target;
        input.onBlur(value === '' ? null : value);
      } }
    />
  </div>
);

NestedArrayObjectFieldInput.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.any,
    onBlur: PropTypes.func
  }).isRequired,
  meta: PropTypes.shape({
    form: PropTypes.string
  }).isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  className: PropTypes.string,
  maxLength: PropTypes.number,
};

NestedArrayObjectFieldInput.defaultProps = {
  placeholder: '',
  type: 'text',
  className: '',
  maxLength: null,
};

const NestedArrayObjectFieldComponent = ({
  component,
  dispatch,
  name,
  rootField,
  formName,
  maxLength,
  custom
}) => (
  <Field
    name={ name }
    component={ FieldChangeWrapper }
    wrappedComponent={ component }
    className="form-input"
    rootField={ rootField }
    { ...custom }
    { ...(maxLength && maxLength > 0 && { maxLength }) }
    onBlur={ (event, newVal, prevVal) => {
      if (!prevVal && !newVal) {
        event.preventDefault();
      }
    } }
    normalize={ (value, prevVal, allValues, prevAllValues) => {
      const rootFieldValue = resolveObjPath(rootField, allValues);
      if (rootFieldValue) {
        let isEachChildNull = true;
        const itemIndex = name.replace(/(^.*\[|\].*$)/g, '');
        const rootFieldItem = rootFieldValue[itemIndex];
        Object
          .keys(rootFieldItem)
          .forEach((key) => {
            if (key != null) {
              if (rootFieldItem[key] != null) {
                isEachChildNull = false;
              }
            }
          });
        if (isEachChildNull) {
          dispatch(arrayRemove(formName, rootField, itemIndex));
          return undefined;
        }
      }
      return value;
    } }
  />
);

NestedArrayObjectFieldComponent.defaultProps = {
  component: NestedArrayObjectFieldInput,
  maxLength: null,
  custom: null
};

NestedArrayObjectFieldComponent.propTypes = {
  component: PropTypes.any,
  dispatch: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  rootField: PropTypes.string.isRequired,
  formName: PropTypes.string.isRequired,
  maxLength: PropTypes.number,
  custom: PropTypes.shape()
};

const mapDispatchToProps = dispatch => ({ dispatch });

// eslint-disable-next-line import/prefer-default-export
export const NestedArrayObjectField = connect(
  null,
  mapDispatchToProps
)(NestedArrayObjectFieldComponent);
